import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = process.env.REACT_APP_SERVER_URL;

export const NewsApi = createApi({
    reducerPath: 'News',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({

        AllNews: builder.query({
            query: (page) => {
                return {
                    url: `/news?page=${page}`,
                    method: 'Get',
                }
            },

        }),

        newDetails: builder.query({
            query: (slug) => {
                return {
                    url: `/new?slug=${slug}`,
                    method: 'Get',
                }
            },

        }),

    })
});

export const {

    useAllNewsQuery,
    useNewDetailsQuery

} = NewsApi